var app = angular.module('leonardo');

var FormErrorsService = function($timeout) {
  var service = {};

  service.goToError = function () {
    if (angular.element('#dynamic-form-popup').length > 0) {
      $timeout(function(){
        var element = angular.element('#dynamic-form-popup .has-error:visible');
        if (element.length === 0)
          element = angular.element('#dynamic-form-popup .error:visible');
        if (element.length !== 0) {
          var top = angular.element(element[0]).offset().top - 40 - angular.element('#dynamic-form-popup').offset().top;
          var top_content = angular.element('#dynamic-form-popup').scrollTop();
          angular.element('#dynamic-form-popup').animate({scrollTop: top + top_content}, "fast");
        }
      }, 100);
    }
    else if (angular.element('.popover').length > 0) {
      $timeout(function(){
        var element = angular.element('.popover .has-error:visible');
        if (element.length === 0)
          element = angular.element('.popover .error:visible');
        if (element.length !== 0) {
          var top = angular.element(element[0]).offset().top - 40 - angular.element('body .popover .popover-content').offset().top;
          var top_content = angular.element('body .popover .popover-content').scrollTop();
          angular.element('body .popover .popover-content').animate({scrollTop: top + top_content}, "fast");
        }
      }, 100);
    }
    else if (angular.element('.ngdialog').length > 0) {
      $timeout(function(){
        var element = angular.element('.ngdialog .has-error:visible');
        if (element.length === 0)
          element = angular.element('.ngdialog .error:visible');
        if (element.length !== 0) {
          var top = angular.element(element[0]).offset().top - 100;
          var top_content = angular.element('body .ngdialog .ngdialog-content').scrollTop();
          angular.element('body .ngdialog .ngdialog-content').animate({scrollTop: top + top_content}, "fast");
        }
      }, 100);
    }
    else {
      $timeout(function(){
        var element = angular.element('.has-error:visible');
        if (element.length === 0)
          element = angular.element('.error:visible');
        if (element.length !== 0) {
          var top = angular.element(element[0]).offset().top - 220;
          var top_content = angular.element('.wrapper-columns-column.region-main .content-column').scrollTop();
          angular.element('.wrapper-columns-column.region-main .content-column').animate({scrollTop: top + top_content}, "fast");
        }
      }, 100);
    }
  };

  return service;
};

app.factory('FormErrorsService', ['$timeout', FormErrorsService]);
